import { render, staticRenderFns } from "./AssetSummary.vue?vue&type=template&id=ca1bcde2&scoped=true"
import script from "./AssetSummary.vue?vue&type=script&lang=js"
export * from "./AssetSummary.vue?vue&type=script&lang=js"
import style0 from "./AssetSummary.vue?vue&type=style&index=0&id=ca1bcde2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1bcde2",
  null
  
)

export default component.exports